/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-04-09 09:18:51
 * @LastEditors: chen
 * @LastEditTime: 2021-04-09 09:20:22
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ticketAndroid'
})
export class TicketAndroidPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value === '1' || value === '2') {
      return 'R';
    }
    if (value === '3' || value === '4' || value === '5' || value === '73') {
      return 'P';
    }
    return null;
  }

}
